import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FilterItem from "./FilterItem";
import Definitions from "../definitions";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Button } from "react-bootstrap";

function LibraryFilter({ items, setItems, resetFilter }) {
  // Grabs a list of all tags/content types currently available
  const [activeItem, setActiveItem] = useState('');

  const [searchFilter, setSearchFilter] = useState("");
  const [activeTag, setActiveTag] = useState("");
  const [activeContentType, setActiveContentType] = useState("");

  const activeFilters = () => {
    
    //"expired"
    let active = { tags: [], content_types: ["all"] };
    // Add expired tag if there is expired content in the library
    let hasExpired = false;
    for(const item of items){
      if(item.tag === "expired"){
        hasExpired = true;
        active.tags.push('expired');
        break;
      }
    }
    
    items.forEach((item) => {
      if (item?.tag in Definitions && !active.tags.includes(item.tag)) {
        active.tags.push(item.tag);
      }
      if (item?.content_type in Definitions && !active.content_types.includes(item.content_type)) {
        active.content_types.push(item.content_type);
      }
    });

    return active;
  };

  // Updates the list of items based on the active filters
  useEffect(() => {
    let returnItems = [...items]; // Clones ref

    // Remove all items where search string does not match
    if (searchFilter != "") {
      returnItems = returnItems.filter( (item) => item.title.toLowerCase().includes(searchFilter.toLowerCase() ));
    }
    // Remove all items where active content type mismatch
    if (activeContentType != "" && activeContentType != "all") {
      
      returnItems = returnItems.filter( (item) => item.content_type == activeContentType);
    }

    if (activeTag != "") {
      returnItems = returnItems.filter( (item) => item.tag == activeTag);
    }

    setItems(returnItems);
  }, [activeTag, activeContentType, searchFilter]);

  const tagItems = activeFilters().tags.map((item) => (
    <option value={item}>{Definitions[item].title}</option>
  ));

  const contentTypeItems = activeFilters().content_types.map((item) => (
    <FilterItem
      title={Definitions[item].title}
      item={item}
      type="content_type"
      activeItem={activeContentType}
      setContentType={setActiveContentType}
    />
  ));

  /**
   * Resets filter. Set input to empty string and reset items to all
   */
  const resetFilters = () => {
    setSearchFilter("");
    setActiveTag("");
    setActiveContentType("");

    resetFilter();
  };

  return (
    <Container className="filter-bar__container">
      <Row className="filter-bar__items">
        <Col className="filter-bar__items--contenttypes">
          {contentTypeItems}
        </Col>
        <Col className="filter-bar__items--filteritems">
          <InputGroup className="mb-3">
            <Form.Control
              type="text"
              value={searchFilter}
              placeholder="Search..."
              onChange={(e) => setSearchFilter(e.target.value)}
            />
            <Form.Select
              value={activeTag}
              aria-label="Default select example"
              onChange={(e) => setActiveTag(e.target.value)}
            >
              <option value="">Content Tag</option>
              {tagItems}
            </Form.Select>

            <Button className="reset-btn" onClick={resetFilters}>
              Reset All
            </Button>
          </InputGroup>
        </Col>
      </Row>
    </Container>
  );
}

export default LibraryFilter;
